/* eslint-disable max-len */
import * as React from 'react';
import { SVGProps, useMemo } from 'react';
import { getIconGradientColors } from './colorUtils';

type PetsColorableProps = SVGProps<SVGSVGElement> & {
  color?: string;
};

const PetsColorable = ({ color, ...props }: PetsColorableProps) => {
  const gradientId = useMemo(
    () => `pets_colorable_${Math.random().toString(36).substr(2, 9)}`,
    [],
  );
  const { primary, secondary } = getIconGradientColors('Pets', color);

  return (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="24" cy="24" r="24" fill={`url(#${gradientId})`} />
      <g transform="translate(9.3, 10.3)" stroke="#F7F5F8" strokeWidth="1.4" strokeMiterlimit="10" fill="none">
        <path d="M14.7002 12.1285C10.4301 12.1285 5.63512 17.5428 5.60012 21.7857C5.57912 24.2857 7.05613 25.7 8.89014 25.7C10.4791 25.7 11.9492 24.1714 14.7002 24.1714" />
        <path d="M13.3001 4.62857C13.3001 7.35 12.0471 8.55714 10.5001 8.55714C8.9531 8.55714 7.7001 7.35 7.7001 4.62857C7.7001 1.90714 9.80011 0.7 10.5001 0.7C11.2001 0.7 13.3001 1.90714 13.3001 4.62857Z" />
        <path d="M6.30002 11.0572C6.30002 13.7786 5.04702 14.9857 3.50001 14.9857C1.95301 14.9857 0.7 13.7786 0.7 11.0572C0.7 8.33573 2.80001 7.12859 3.50001 7.12859C4.20002 7.12859 6.30002 8.33573 6.30002 11.0572Z" />
        <path d="M14.7 12.1285C18.97 12.1285 23.765 17.5428 23.8 21.7857C23.821 24.2857 22.344 25.7 20.51 25.7C18.921 25.7 17.451 24.1714 14.7 24.1714" />
        <path d="M16.0998 4.62857C16.0998 7.35 17.3528 8.55714 18.8998 8.55714C20.4468 8.55714 21.6998 7.35 21.6998 4.62857C21.6998 1.90714 19.5998 0.7 18.8998 0.7C18.1998 0.7 16.0998 1.90714 16.0998 4.62857Z" />
        <path d="M23.0999 11.0572C23.0999 13.7786 24.3529 14.9857 25.8999 14.9857C27.4469 14.9857 28.6999 13.7786 28.6999 11.0572C28.6999 8.33573 26.5999 7.12859 25.8999 7.12859C25.1999 7.12859 23.0999 8.33573 23.0999 11.0572Z" />
      </g>
      <defs>
        <linearGradient id={gradientId} x1="6" y1="4" x2="35" y2="48" gradientUnits="userSpaceOnUse">
          <stop stopColor={primary} />
          <stop offset="1" stopColor={secondary} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default PetsColorable;
